<app-guest-recommendations-reviews-desktop *ngIf="isDesktopMode()"></app-guest-recommendations-reviews-desktop>
<app-guest-recommendations-reviews-mobile *ngIf="!isDesktopMode()"></app-guest-recommendations-reviews-mobile>
